module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('article', {
    attrs: {
      "epub:type": "frontmatter"
    }
  }, [_c('section', {
    attrs: {
      "epub:type": "division"
    }
  }, [_c('p', {
    staticClass: "center",
    staticStyle: {
      "font-size": "150%",
      "margin-top": "2em",
      "margin-bottom": "5em"
    },
    attrs: {
      "id": "fm1"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pageviii",
      "title": "viii"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_1",
      "title": "1"
    }
  }, [_c('em', [_vm._v("The Master and Margarita")])])])]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('div', {
    staticClass: "poetry"
  }, [_c('p', {
    staticClass: "hanging"
  }, [_vm._v("“…so who are you in the end?”")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("“I am a part of that power which eternally desires evil and eternally does good.”")]), _vm._v(" "), _c('p', {
    staticClass: "hanging1"
  }, [_vm._v("Goethe, "), _c('em', [_vm._v("Faust")]), _c('span', {
    attrs: {
      "href": "#/OEBPS/note#ftn1",
      "id": "fnt1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a86f023","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/fm1.vue
// module id = 69
// module chunks = 0